import {LiaArrowAltCircleRight} from "react-icons/lia";
import {directionsUrl, externalIntegrationsEnabled} from "../utils/deliveryAddress";
export const DirectionsLink = ({address}) => {
  const url = directionsUrl(address);
  if (url && externalIntegrationsEnabled) return <a href={url} aria-label="Cómo llegar a la dirección del pedido"><LiaArrowAltCircleRight aria-hidden="true"/> Cómo llegar</a>;
  return <div><button type="button" disabled aria-label="Cómo llegar no disponible">Cómo llegar</button>
    <small style={{display:"block"}}>{externalIntegrationsEnabled ? "Dirección no disponible" : "Rutas externas desactivadas en este entorno"}</small></div>;
};
